import { areaLayers } from '../catalogueLayerStyle';
import type { CatalogueLayer } from '../catalogueLayers';

/** This module holds what is true of the dataset on every map. How one page uses it
 *  belongs to that page. */

/** A green. It must stay distinct from the cyan of a site. */
export const PROTECTED_AREA_THEME = 'rgb(46, 125, 80)';

/** The collection engine ADR-022 publishes. */
export const PROTECTED_AREAS_CATALOGUE_LAYER: CatalogueLayer = {
    id: 'protected-areas',
    collectionId: 'protected-areas',
    label: 'Protected areas',
    layers: areaLayers(PROTECTED_AREA_THEME),
};
